import { UserContextState } from "@contexts/UserContext";
import { useIntercom } from "react-use-intercom";
import { useEffect } from "react";
import { generateHMAC } from "@utils/hmac";
import { useRouter } from "next/router";
import { Route } from "nextjs-routes";

const PATHS_THAT_SHOULD_HIDE_INTERCOM: Set<Route["pathname"]> = new Set([
  "/builder/path-version/[id]",
  "/builder/course-version/[id]",
  "/library/library-item/[id]",
]);

const useUpdateIntercom = (userContext?: UserContextState): void => {
  const {
    update: updateIntercom,
    hide: hideIntercom,
    trackEvent,
  } = useIntercom();
  const router = useRouter();
  useEffect(() => {
    if (
      userContext?.user &&
      process.env.NEXT_PUBLIC_VERCEL_ENV === "production" &&
      !userContext.isStaff
    ) {
      const payload = {
        userId: userContext.user.id.toString(),
        userHash: generateHMAC(
          process.env.NEXT_PUBLIC_INTERCOM_SECRET_KEY!,
          userContext.user.id.toString(),
        ),
        email: userContext.user.email || undefined,
        name: userContext.user.name!,
        company: {
          companyId: userContext.user.org!.id.toString(),
          name: userContext.user.org?.name,
        },
      };
      updateIntercom(payload);
      trackEvent("dashboard-loaded");
      hideIntercom();
    }
  }, [userContext]); // eslint-disable-line react-hooks/exhaustive-deps
  useEffect(() => {
    PATHS_THAT_SHOULD_HIDE_INTERCOM.has(router.pathname)
      ? updateIntercom({ hideDefaultLauncher: true })
      : updateIntercom({ hideDefaultLauncher: false });
  }, [updateIntercom, router.pathname]);
};

export default useUpdateIntercom;
